<template>
    <b-modal v-model="modalAberto" size="lg" @hidden="cancelar" button-size="md" hide-footer
        title="Item Bem Permanente > Avaliação de Estado de Conservação > Cadastro" >
        <AvaliacaoEstadoConservacaoAdicionar @fecharModal="cancelar" :modal="true" :id="id"></AvaliacaoEstadoConservacaoAdicionar>
    </b-modal>
</template>

<script>

import AvaliacaoEstadoConservacaoAdicionar from '@/modules/patrimonio/avaliacao-estado-conservacao/AvaliacaoEstadoConservacaoAdicionar.vue';

export default {
    name: "ModalAvaliacaoEstadoConservacaoAdicionar",
    components: {
        AvaliacaoEstadoConservacaoAdicionar
    },
    props: {
        id: Number,
    },
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        cancelar() {
            this.$emit('fecharModal');
        },

    }
}

</script>